import border from '../../border';

const custom = (params) => border.disabled.custom(params);

export default custom;
